import { useState } from 'react';
import { Wizard } from 'taboola-ultimate-ui';
import { FORM_MODES } from 'config/formModes';
import { withFormDataProvider } from 'modules/taboola-common-frontend-modules/formData';
import { codelessInitialValues } from '../config/CodelessInitialValues/codelessInitialValues';
import { conversionTabItems } from '../config/conversionTabItems';
import { getViewComponents } from '../config/getViewComponents';
import { useConversions } from '../hooks/useConversions';
import { useStepProperties } from '../hooks/useStepProperties';
import { useTabHeadersAndContent } from '../hooks/useTabHeadersAndContent';
import { useTabStepNavigation } from '../hooks/useTabStepNavigation';
import { Frame } from './Frame';

const ConversionSetup = () => {
    const { conversions } = useConversions();

    const [isFrameVisible, setIsFrameVisible] = useState(true);

    const handleCloseFrame = () => setIsFrameVisible(false);
    const {
        steps,
        currentStep,
        goNext,
        goBack,
        resetSteps,
        switchTab,
        currentView,
        handleGoBackToSetup,
        handleFinishSetup,
        handleSetCurrentIndex,
        handleNavigateMode,
        currentIndex,
        isNavigateMode,
        handleEditClick,
        setFocusedConversionId,
        existingConversionIds,
    } = useTabStepNavigation(conversionTabItems);

    const { tabHeaders, tabContent } = useTabHeadersAndContent(
        conversions,
        switchTab,
        currentStep,
        goNext,
        goBack,
        handleSetCurrentIndex,
        currentIndex,
        resetSteps,
        handleEditClick,
        setFocusedConversionId,
        existingConversionIds
    );
    const { isStyleFrame, showTabNavigation } = useStepProperties(steps, currentStep);

    const viewComponents = getViewComponents({
        showTabNavigation,
        tabHeaders,
        tabContent,
        steps,
        currentStep,
        goNext,
        goBack,
        resetSteps,
        handleFinishSetup,
        handleGoBackToSetup,
        handleSetCurrentIndex,
        handleNavigateMode,
        currentIndex,
        handleCloseFrame,
        isNavigateMode,
        setFocusedConversionId,
    });

    if (!isFrameVisible) {
        return null;
    }

    return <Frame isStyleFrame={isStyleFrame}>{viewComponents[currentView]()}</Frame>;
};

const ConversionSetupWithFormDataProvider = withFormDataProvider(ConversionSetup, {
    defaultValuesConfig: codelessInitialValues,
    formContainerId: Wizard.WIZARD_CONTAINER_ID,
    mode: FORM_MODES.CREATE,
    isNetworkOwnerAllowed: true,
});

export { ConversionSetupWithFormDataProvider as ConversionSetup };
